import React from 'react';

import Icon from '../Icon/Icon';

const SmallCloudBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd'>
                <path
                    d='M26.667 17c1.567 0 2.987.62 4.014 1.625a5.435 5.435 0 0 1 1.604 4.62l-.11.824.79.26a2.998 2.998 0 0 1 1.48 1.07c.349.475.555 1.058.555 1.688 0 .802-.334 1.527-.87 2.052A3.035 3.035 0 0 1 32 30H16a3.036 3.036 0 0 1-2.13-.861 2.862 2.862 0 0 1-.87-2.052c0-.64.212-1.23.57-1.71a3.004 3.004 0 0 1 2.108-1.186c.014-.206.043-.412.09-.617a4.2 4.2 0 0 1 1.512-2.379 4.387 4.387 0 0 1 2.72-.934c.238 0 .47.018.698.054l.679.107.343-.596a5.624 5.624 0 0 1 2.082-2.07A5.751 5.751 0 0 1 26.667 17z'
                    stroke='#34303D'
                />
                <path
                    d='M28.51 24c.122-.264.19-.556.19-.863 0-1.18-1.003-2.137-2.24-2.137-.843 0-1.578.446-1.96 1.104'
                    stroke='#00D1D2'
                    strokeLinecap='round'
                    className='icon-accent-stroke'
                />
            </g>
        </Icon>
    );
};

export default SmallCloudBlueIcon;
